import vatRatesJs from '../data/vatRates.json';
import * as vatRatesTs from '../data/vatRates.json';
const vatRates = vatRatesJs || vatRatesTs;
const VatRatesMgrFactory = () => {
    return {
        getVatRates() {
            return vatRates;
        },
        getVatRate(countryCode) {
            const isDefaultVatRate = (vatRat) => {
                return vatRat.countryCode === '' && vatRat.countryName === '';
            };
            const vatRate = this.getVatRates().find((vatRate) => vatRate.countryCode === countryCode);
            return vatRate ? vatRate : this.getVatRates().find((vatRate) => isDefaultVatRate(vatRate));
        },
        getPricelistVatRate(orderLines, inPercent = true) {
            const [{ vatRatePerMille } = { vatRatePerMille: undefined }] = orderLines;
            const PER_MILLE = inPercent ? 10 : 10000;
            return vatRatePerMille === undefined ? vatRatePerMille : vatRatePerMille / PER_MILLE;
        },
        getPricelistVatRatePerMille(vatRatePerMille, inPercent = true) {
            const PER_MILLE = inPercent ? 10 : 10000;
            return vatRatePerMille === undefined ? vatRatePerMille : vatRatePerMille / PER_MILLE;
        },
        calculateTotalVat(productPrice, vatRate, isVatIncludedInProductPrice = false) {
            const PERCENTAGE = 100;
            const WHOLE = 1;
            const DIVIDER = WHOLE + vatRate / PERCENTAGE;
            if (isVatIncludedInProductPrice) {
                const basePrice = productPrice / DIVIDER;
                return productPrice - basePrice;
            }
            else {
                const totalPrice = productPrice * DIVIDER;
                return totalPrice - productPrice;
            }
        },
    };
};
export const calculateVat = (vatRatePerMille, totalPrice) => {
    const vatRatesMgr = VatRatesMgrFactory();
    const vatRate = vatRatesMgr.getPricelistVatRatePerMille(vatRatePerMille || 0);
    return vatRatesMgr.calculateTotalVat(totalPrice, vatRate, true);
};
export default VatRatesMgrFactory;
